<template>
	<div class="">
		<div
			v-for="(item, index) in items"
			:key="index"
			class="container__checkbox"
		>
			<input
				:id="item.id"
				v-model="internalValue"
				type="checkbox"
				:value="item.value"
				:disabled="item.disabled"
				class="checkbox"
			/>
			<label
				:for="item.id"
				class="label"
				:class="{ 'label-checked': internalValue.includes(item.value) }"
			>
				{{ item.label }}
			</label>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CheckboxGroup',
	props: {
		items: {
			type: Array,
			required: true,
			default: () => [],
		},
		value: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			internalValue: this.value,
		}
	},
	watch: {
		value(newValue) {
			if (JSON.stringify(newValue) !== JSON.stringify(this.internalValue)) {
				this.internalValue = newValue
			}
		},
		internalValue(newValue) {
			this.$emit('input', newValue)
		},
	},
}
</script>

<style scoped>
.container {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
}

.container__checkbox {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	font-size: 0.875rem;
}

.checkbox {
	width: 1rem;
	height: 1rem;
	accent-color: #34617e;
	cursor: pointer;
}

.checkbox:disabled {
	cursor: not-allowed;
}

.label {
	color: #464947;
	cursor: pointer;
}

.label-checked {
	font-weight: bold; /* Aplica negrito diretamente */
}
</style>
